module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('pago.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "order": _vm.order,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', [(items.item.estado == 'PENDIENTE') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "error",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'HABILITADO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'PAGADO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(items.item.tipo == 'ENTIDAD') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.tipo) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.tipo == 'CANCILLERIA') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.tipo) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.titular_factura))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nro_documento))]), _vm._v(" "), _c('td', _vm._l((items.item.cpt), function(value, key) {
          return _c('span', [(key === 'cpt') ? _c('span', [_vm._v("\n                  " + _vm._s(value) + "\n                ")]) : _vm._e()])
        }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.id_tramite_doc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item._created_at, 'dd/MM/YYYY hrs. HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha_pago, 'dd/MM/YYYY hrs. HH:mm')))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bd00da8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/pago/Pago.vue
// module id = 525
// module chunks = 2